import { ReactElement, memo } from 'react';

import { Tooltip, TooltipContent, TooltipTrigger } from 'components/ui/tooltip';

import { UNAUTHORIZED_MESSAGE } from 'lib/constants/role-types';

type TooltipUnauthorizedMessageProps = {
  hasPermission: boolean;
  children: ReactElement<any>;
};

const TooltipUnauthorizedMessage = memo<TooltipUnauthorizedMessageProps>(
  ({ hasPermission, children }) =>
    hasPermission ? (
      children
    ) : (
      <Tooltip disableHoverableContent>
        <TooltipTrigger asChild>{children}</TooltipTrigger>
        <TooltipContent side="top">{UNAUTHORIZED_MESSAGE}</TooltipContent>
      </Tooltip>
    ),
);

export default TooltipUnauthorizedMessage;
